export class UriGenerator {
    private _uri: string;
    get Uri(): string {
        return this._uri;
    }

    constructor(uriBase: string) {
        this._uri = uriBase;
    }

    public setParam(key: string, value: string) {
        if (this._uri.indexOf('?') === -1) {
            this._uri += '?';
        }
        if (this._uri[this._uri.length - 1] === '?') {
            this._uri += `${key}=${value}`;
        } else {
            this._uri += `&${key}=${value}`;
        }
    }
}
